import React from 'react';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { apiGet } from '../utils/api';
import LoadingSpinner from './LoadingSpinner';

export default function Rules({ t, slug }) {
  const { data: rules, isLoading, isError } = useQuery({
    queryKey: ['rules', slug],
    queryFn: () => apiGet(`/v1/clan/${slug}/rules`),
    enabled: !!slug,
    placeholderData: keepPreviousData,
  });

  // Default footer text - this is still translated
  const footerText = t('rules_footer', { defaultValue: 'Alle Regeln dienen der Fairness und dem Erfolg des Clans. Bei Fragen wendet euch bitte an die Clan-Leitung.' });

  if (isLoading) {
    return (
      <div id="rulesPage">
        <h1 className="text-2xl md:text-3xl mb-6">📜 <span>{t('page_rules')}</span></h1>
        <div className="bg-gray-800 rounded-xl">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div id="rulesPage">
        <h1 className="text-2xl md:text-3xl mb-6">📜 <span>{t('page_rules')}</span></h1>
        <div className="bg-gray-800 p-6 rounded-xl text-center text-red-400">{t('error_loading_data')}</div>
      </div>
    );
  }

  // No rules yet
  if (!rules || rules.length === 0) {
    return (
      <div id="rulesPage">
        <h1 className="text-2xl md:text-3xl mb-6">📜 <span>{t('page_rules')}</span></h1>
        <div className="bg-gray-800 p-6 rounded-xl text-center text-gray-400">
          {t('rules_empty')}
        </div>
      </div>
    );
  }

  const RULE_ACCENTS = ['blue', 'gold', 'purple', 'teal', 'emerald'];

  return (
    <div id="rulesPage">
      <h1 className="text-2xl md:text-3xl mb-6">📜 <span>{t('page_rules')}</span></h1>

      <div id="rulesContainer" className="rules-container">
        {rules.map((section, si) => {
          const accent = RULE_ACCENTS[si % RULE_ACCENTS.length];
          return (
            <div key={si} className={`rules-section rules-accent-${accent}`}>
              <h2 className="rules-section-title">
                <span className="rules-section-icon">{section.icon || '📋'}</span>
                {section.title}
              </h2>
              <div className="rules-entries">
                {section.entries && section.entries.map((entry, ei) => (
                  <div key={ei} className="rule-entry">
                    <span className="rule-number">{ei + 1}</span>
                    <div className="rule-body">
                      <div className="rule-label">{entry.label}</div>
                      <div className="rule-content">{entry.content}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
        <div className="rules-footer">ℹ️ {footerText}</div>
      </div>
    </div>
  );
}
